import { useQuery } from '@tanstack/react-query';

import { indirectTaxContentIngestionKeys } from './keys';
import { fetchContentIngestionJob } from './refreshContentIngestion';
import {
  IIndirectTaxContentIngestionJobResponse,
  INDIRECT_TAX_CONTENT_INGESTION_RUNNING_STATUSES,
} from './types';

const POLL_INTERVAL_MS = 5_000;

const RUNNING_STATUSES = new Set(
  INDIRECT_TAX_CONTENT_INGESTION_RUNNING_STATUSES
);

/** Pass a null jobId to hold the request until a refresh has been queued. */
export function useContentIngestionJob(jobId: string | null) {
  return useQuery({
    queryKey: indirectTaxContentIngestionKeys.FETCH_JOB(jobId ?? ''),
    queryFn: (): Promise<IIndirectTaxContentIngestionJobResponse> =>
      fetchContentIngestionJob(jobId as string),
    enabled: Boolean(jobId),
    refetchInterval: (query) => {
      const status = query.state.data?.job.status;
      return status && RUNNING_STATUSES.has(status) ? POLL_INTERVAL_MS : false;
    },
  });
}
